


































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import Thdata from "../../../store/entities/thdata";
import Echarts from "../threaltimedata/Echarts.vue";
import EchartsHumi from "../threaltimedata/Echarts.vue";
import PageRequest from "@/store/entities/page-request";
// import echarts from 'Echarts'
Vue.prototype.$echarts = Echarts;
class PageThRealTimeDataRequest extends PageRequest {
  AddTime: Date = new Date();
  SNID: String;
  locationName: String;
  StartDate: Date = new Date();
  EndDate: Date = new Date();
  timetype: Number = 0;
  Id: Number;
}
@Component({
  components: { Echarts, EchartsHumi },
})
export default class AnalyseThrealtimedata extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  @Prop({ type: Date }) EndTime: Date;
  @Prop({ type: String }) locationName: String;
  pagerequest: PageThRealTimeDataRequest = new PageThRealTimeDataRequest();
  componentKey: number = 10;
  componentKeyhumi: number = 10;
  mac = "";
  eqid = 0;
  datalist = [];
  StartTime: string;
  list = [];
  title: string = "数据分析";
  tempmessage: string = "";
  humimessage: string = "";
  numbermessage: string = "";
  datetype: string = "day";
  startDate: Date = new Date();
  endDate: Date = new Date();
  monthDate: Date = new Date();
  polar: string = "";
  maxtemp: string = "";
  mintemp: string = "";
  maxhumi: string = "";
  minhumi: string = "";
  MaxNumber: string = "";
  labellist = [
    "温度",
    "湿度",
    "PM2.5",
    "PM10",
    "VOC挥发物",
    "风速",
    "风向",
    "噪音",
    "大气压",
  ];
  async getPage() {
    //filters
    //debugger;
    //let ss=this.value;
    if (this.pagerequest.timetype != 1) {
      this.pagerequest.StartDate = this.EndTime;
      this.pagerequest.EndDate = this.EndTime;
    }
    this.datalist = [];
    this.pagerequest.AddTime = this.EndTime;
    this.pagerequest.SNID = this.mac;
    this.list = await this.$store.dispatch({
      type: "outair_data/getPagedLast",
      data: this.pagerequest,
    });
    //this.ThisThPaged();
    let list = [];
    this.labellist.forEach((e, i) => {
      list.push({
        name: e,
        type: "line",
        data: [],
        areaStyle: {
          opacity: 0.8,
          color: {
            colorStops: [
              {
                offset: 0,
                color: "rgba(1,191,236)",
              },
              {
                offset: 1,
                color: "rgba(84, 112, 198)",
              },
            ],
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            type: "linear",
            global: false,
          },
        },
        markPoint: {
          data: [
            { type: "max", name: "最大值" },
            { type: "min", name: "最小值" },
          ],
        },
      });
    });
    let timelist = [];
    // for (let i = 0; i < 24; i++) {
    //   timelist.push(i.toString() + ":00");
    // }

    let datalist_temp = [];
    let datalist_humi = [];
    let datalist_pM25 = [];
    let datalist_pM10 = [];
    let datalist_voc = [];
    let datalist_wind_speed = [];
    let datalist_wind_direction = [];
    let datalist_noise = [];
    let datalist_pressure = [];
    for (let entry of this.list) {
      timelist.push(
        this.GetDays(entry.addTime) + " " + this.GetMinutes(entry.addTime)
      );
      datalist_temp.push(entry.temp);
      datalist_humi.push(entry.humi);
      datalist_pM25.push(entry.pM25);
      datalist_pM10.push(entry.pM10);
      datalist_voc.push(entry.voc);
      datalist_wind_speed.push(entry.wind_speed);
      datalist_wind_direction.push(entry.wind_direction);
      datalist_noise.push(entry.noise);
      datalist_pressure.push(entry.pressure);
    }
    this.tempmessage = datalist_temp[datalist_temp.length - 1];
    this.humimessage = datalist_humi[datalist_temp.length - 1];
    list.forEach((e, i) => {
      if (i == 0) {
        e.data = datalist_temp;
      } else if (i == 1) {
        e.data = datalist_humi;
      } else if (i == 2) {
        e.data = datalist_pM25;
      } else if (i == 3) {
        e.data = datalist_pM10;
      } else if (i == 4) {
        e.data = datalist_voc;
      } else if (i == 5) {
        e.data = datalist_wind_speed;
      } else if (i == 6) {
        e.data = datalist_wind_direction;
      } else if (i == 7) {
        e.data = datalist_noise;
      } else if (i == 8) {
        e.data = datalist_pressure;
      }
    });
    list.forEach((e, i) => {
      let echartlist = {
        label: this.labellist[i],
        title: this.labellist[i] + "走势图",
        legenddata: JSON.stringify(this.labellist[i]),
        xAxisdata: JSON.stringify(timelist),
        seriesdata: JSON.stringify(e),
      };
      this.datalist.push(echartlist);
    });
    this.showEcharts();
  }
  async getThreshold() {
    var thresholdId;
    this.pagerequest.Id = this.eqid;
    var elist = await this.$store.dispatch({
      type: "outair_equipment/get",
      id: this.eqid,
    });
    if (elist.gId != "" && elist.gId != 0) {
      thresholdId = elist.gId;
    }
    var threshold = await this.$store.dispatch({
      type: "outair_threshold/get",
      id: thresholdId,
    });
    this.maxtemp = threshold.maxtemp;
    this.mintemp = threshold.mintemp;
    this.maxhumi = threshold.maxhumi;
    this.minhumi = threshold.minhumi;
    this.MaxNumber = threshold.maxNumber;
  }
  GetMinutes(time) {
    let date = new Date(time);
    let Str =
      this.GetBqMinutes(date.getHours()) +
      ":" +
      this.GetBqMinutes(date.getMinutes());
    return Str;
  }
  GetDays(time) {
    let date = new Date(time);
    let Str =
      this.GetBqMinutes(date.getMonth() + 1) +
      "." +
      this.GetBqMinutes(date.getDate());
    return Str;
  }
  GetBqMinutes(str) {
    if (str.toString().length == 1) {
      return "0" + str;
    }
    return str;
  }
  visibleChange(value: boolean) {
    // this.ThisThPaged();

    if (!value) {
      this.$emit("input", value);
      this.$emit("title", this.locationName);
    } else {
      let sdata = this.$store.state.outair_equipment.analyseoutair;
      this.mac = sdata.snid;
      this.eqid = sdata.id;
      this.pagerequest.timetype = 0;
      this.getPage();
      this.getThreshold();
    }
  }

  cancel() {
    //this.getPage();
    this.$emit("input", false);
  }

  showEcharts() {
    this.componentKey += 1;
    this.componentKeyhumi += 1;
  }
  GetByDate() {
    if (
      this.pagerequest.StartDate.toString() != "" &&
      this.pagerequest.EndDate.toString() != ""
    ) {
      this.pagerequest.SNID = this.mac;
      this.pagerequest.timetype = 1;
      this.getPage();
    }
  }
  GetByMonth() {
    if (this.monthDate.toString() != "") {
      var currentY = this.monthDate.getFullYear();
      var currentM = this.monthDate.getMonth() + 1;
      var lastM = new Date(currentY, currentM, 0);
      var lastS = new Date(currentY, currentM - 1);
      this.pagerequest.StartDate = lastS;
      this.pagerequest.EndDate = lastM;
      this.pagerequest.SNID = this.mac;
      this.pagerequest.timetype = 1;
      this.getPage();
    }
  }
}
